import { createGlobalStyle } from 'styled-components'

export const Variables = createGlobalStyle`
  :root {
    --primary: #FFB4BE;
    --secondary: #26A69A;
    --bg-primary: #111828;
    --bg-secondary: #1F2937;
    --bg-tertiary: #374151;
    --positive: #21BA45;
    --accent: #9C27B0;
    --negative: #C10015;
    --info: #31CCEC;
    --warning: #F2C037;
    --dark: #1D1D1D;
    --dark-page: #121212;
  }
`
